



















import { Component, Vue } from 'vue-property-decorator';
import {
  UserInfo,
  RootState,
  RootActionLogOut,
  RootActionGetFavor,
  RootMutationShowDialog,
  Dialog,
} from '@/store/interface';
import { State, Action, Mutation } from 'vuex-class';
import { rootActions, rootMutations } from '@/store/types';

@Component
export default class Me extends Vue {
  @State((state: RootState) => state.user)
  private user!: UserInfo | null;
  @State((state: RootState) => state.addPrefix)
  private addPrefix!: boolean;
  @Mutation(rootMutations.TOGGLE_ADD_PREFIX)
  private toggle!: () => void;
  @Mutation(rootMutations.SHOW_DIALOG)
  private showDialog!: RootMutationShowDialog;
  @Action(rootActions.LOGOUT)
  private logOut!: RootActionLogOut;
  @Action(rootActions.GET_MYFAVORITES)
  private getMyFavorites!: RootActionGetFavor;
  private created() {
    this.getMyFavorites();
  }
  private activated() {
    this.getMyFavorites();
  }
  private logInOrOut() {
    if (this.user) {
      const dialog: Dialog = {
        title: '注意?',
        content: '确认退出登陆?',
        successCb: () => this.logOut(),
      };
      this.showDialog(dialog);
    } else {
      this.$router.push('/login');
    }
  }
}
